import { AddCircleOutline } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { SystemAdminDocumentCategoryTableContainer } from 'src/containers/document-categories/SystemAdminDocumentCategoryTableContainer'
import { CreateDocumentCategoryDialog } from 'src/components/document-categories/system-admin/CreateDocumentCategoryDialog'

export const SystemAdminDocumentCategories = () => {
  const { t: translate } = useTranslation(['document-category', 'common', 'common-api-message'])
  const { showDialog } = useDialogCtx()
  const theme = useTheme()

  const onAddDocumentCategory = async () => {
    const added = await showDialog(
      CreateDocumentCategoryDialog,
      {
        opts: {
          maxWidth: 'sm',
          fullWidth: true,
        },
      },
      undefined,
      true,
    )
    if (!added) return
  }
  return (
    <>
      <CommonPageLayout
        titleSection={{ title: translate('document-category', { ns: 'document-category' }) }}
        topAction={[
          {
            buttonText: translate('document-category', { ns: 'document-category' }),
            buttonIcon: <AddCircleOutline />,
            onClick: onAddDocumentCategory,
            variant: 'outlined',
            shadowWeight: null,
            border: 0,
          },
        ]}
      >
        <Box padding={'8px'} bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius={'4px'}>
          <SystemAdminDocumentCategoryTableContainer />
        </Box>
      </CommonPageLayout>
    </>
  )
}
